/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { EuiCollapsibleNavBeta, EuiHeaderSection } from "@inscopix/ideas-eui";
import { HeaderNavHome } from "./HeaderNavHome";
import { HeaderNavProfile } from "./HeaderNavProfile";

const styles = {
  headerSection: css`
    .euiButtonIcon.euiCollapsibleNavButton {
      color: #fff !important;
    }
  `,
};

interface HeaderNavProps {
  children: React.ReactNode;
}

// Wrapping header component that displays home, profile, and children
export const HeaderNav = ({ children }: HeaderNavProps) => {
  return (
    <EuiHeaderSection grow={false} css={styles.headerSection}>
      <EuiCollapsibleNavBeta initialIsCollapsed={true}>
        <EuiCollapsibleNavBeta.Body>
          <HeaderNavHome />
          {children}
          <HeaderNavProfile />
        </EuiCollapsibleNavBeta.Body>
      </EuiCollapsibleNavBeta>
    </EuiHeaderSection>
  );
};
